import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';

import { UserService } from '../../../shared/services/user.service';

export const claimGuard: CanActivateFn = () => {
	const router = inject(Router);
	const { user } = inject(UserService);
	if (!user.hasService('QUAPP')) {
		return router.createUrlTree(['/']);
	}
	return true;
};
